import { Link } from "react-router-dom";
export default function Logo() {
    return (
        <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-african-accent flex items-center justify-center">
                <span className="text-white font-display font-bold text-xl">S</span>
            </div>
            <span className="font-display font-bold text-2xl text-foreground">Sekuu</span>
        </Link>
    );
}